<div class="background">
    <div class="header">
        <h3>Edit {{ data.field }} of {{ data.property }}: </h3>
        <button mat-icon-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div>
        <label class="custom-label">
            <span style="margin-right: 4px; display: inline-flex; vertical-align: middle;"><mat-icon>developer_board</mat-icon></span>Developer
        </label>
        <textarea [(ngModel)]="developersText" (ngModelChange)="onTextareaChange(1)" type="text"
                  class="custom-text-area text"></textarea>
        <div [align]="'end'">
            <button (click)="editValue(1)"
                    [disabled]="!((permissionService.accessRights$|async)?.userRight_RIS2_EDIT_DEV_TEXTS$|async)
                        || developersText === initialLocalDevelopersText || editPressedValues[1]"
                    color="primary" mat-raised-button>Save
            </button>
        </div>

        @if (localTranslations.length > 0) {
            @for (language of (languages$ | async); track language; let index = $index) {
                @if (language.id !== 1) {
                    <label class="custom-label">
                        @if (language.id === 2) {
                            <span class="fi fi-de"></span> {{ language.name }}
                        } @else if (language.id === 3) {
                            <span class="fi fi-gb"></span> {{ language.name }}
                        }
                    </label>
                    <textarea [(ngModel)]="localTranslations[index]" (ngModelChange)="onTextareaChange(language.id!)"
                              type="text" class="custom-text-area text"></textarea>
                    <div [align]="'end'">
                        <button (click)="editValue(language.id!)" color="primary" mat-raised-button
                                [disabled]="localTranslations[index] === initialLocalTranslations[index] || editPressedValues[language!.id!]">
                            Save
                        </button>
                        @if (index + 1 === (languages$ | async)?.length) {
                            <button (click)="editAllValues()" style="float: left"
                                    [disabled]="!(((permissionService.accessRights$|async)?.userRight_RIS2_EDIT_PRODUCT$|async) &&
                                                ((permissionService.accessRights$|async)?.userRight_RIS2_EDIT_PRODUCT_TRANSLATION$|async))
                                                || editPressedAll || !allEnabled()" color="primary" mat-raised-button>
                                Save All
                            </button>
                        }
                    </div>
                }
            }
        }
    </div>
    <mat-card
            [ngClass]="{'status-edited': (editedValue$ | async) === true, 'status-failed': (editedValue$ | async) === false,
            'status-not-edited': !(editPressedAll || editPressedValue)}" class="edited-card">
        @if (editPressedAll || editPressedValue) {
            <p>{{ (editedValue$ | async) ? "Your Change has been made." : "Your Change could not be made." }}</p>
        } @else {
            <p>Press 'Save' to submit your change.</p>
        }
    </mat-card>
</div>
